import React from 'react';
import RateSetInfoTemplate from '../../../generic-components/rate-forms/rate-set-info-template.jsx';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import RateTemplate from '../../../generic-components/rate-tables/rate-table-template-container';
import TaxCurrencyCommissionForm from '../../../generic-components/rate-forms/tax-currency-commission-form';
import pluralize from 'pluralize';

const EditRateSet = ({
  productType,
  productName,
                       data,
  onTextFieldChangeWithKeyPath,
                       updateFormData,
                       paxMax,
                       twinBedsAvail,
  contractState,
  updateTableCell,
                       maxAdultsPlusChild,
                       ...extraProps,
                     }) => {
  const invalidRateDescrs = productType === 'Non-Accommodation'
    ? []
    : extraProps.rates.filter(obj => {
      if (obj.notApplicable) return false;
      if (obj.description === 'Twin') return !twinBedsAvail;
      return obj.maxAdults > paxMax;
    })
      .map(obj => obj.description);
  const basePath = ['data', 'rateSets', data.rateSetsIndex];
  return (
    <div style={{ padding: '24px' }}>
      {
        /*
         <span style={{ position: 'relative', top: '-12px' }}>Assign Rate Set to Another Season</span>
         <div style={{ width: '260px', display: 'inline-block', marginLeft: '12px' }}>
         <Select
         name="selectSeason"
         options={existingSeasons.map((season, seasonIndex) => ({ value: seasonIndex, label: season.seasonName }))}
         value={data.seasonRatesIndex}
         optionRenderer={option => <span style={{ color: option.value === data.seasonRatesIndex ? '#ff4081' : '' }}>{option.label}</span>}
         onChange={({ value }) => onTextFieldChange({ key: 'seasonRatesIndex', value })}
         clearable={false}
         scrollMenuIntoView={false}
         />
         </div><br /><br />
         */
      }
      <RateSetInfoTemplate
        {...extraProps}
        rateSetsIndex={data.rateSetsIndex}
        productType={productType}
        productName={productName}
        updateFieldValue={(key, value) => onTextFieldChangeWithKeyPath({ keyPath: [...basePath, key], value })}
        updateDaysOfWeek={(checked, day) => {
          if (day === 'All') {
            onTextFieldChangeWithKeyPath({ keyPath: [...basePath, 'daysOfWeek'], value: checked ? ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'] : [] });
          } else {
            const newDaysOfWeek = checked ? [...extraProps.daysOfWeek, day] : extraProps.daysOfWeek.filter(thisDay => thisDay !== day);
            onTextFieldChangeWithKeyPath({ keyPath: [...basePath, 'daysOfWeek'], value: newDaysOfWeek });
          }
        }}
      />

      {
        productType === 'Accommodation' ? <div>
          <TypeControlledTextField
            id={`maxAdultsPlusChild${data.rateSetsIndex}`}
            controlledType="number"
            style={{ display: 'inline-block', width: '50%' }}
            hintStyle={{ fontSize: '14px' }}
            floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
            inputStyle={{ fontSize: '14px' }}
            hintText="Whole number only"
            floatingLabelText="Max Occupancy (Adults + Children)"
            value={maxAdultsPlusChild}
            onChange={({ target: { value } }) => {
              onTextFieldChangeWithKeyPath({
                keyPath: [...basePath, 'rates'],
                value: extraProps.rates.map(rate => ({ ...rate, maxAdultsPlusChild: value })),
              });
            }}
          /><span style={{ color: 'red', marginLeft: '5px', fontSize: '24px', verticalAlign: 'bottom' }}> *</span>
        </div> : <div/>
      }
      <TaxCurrencyCommissionForm
        taxInclusion={extraProps.taxInclusion}
        taxType={extraProps.taxType}
        currency={extraProps.currency}
        rateType={extraProps.rateType}
        commissionPercentage={extraProps.commissionPercentage}
        nettCommission={extraProps.nettCommission}
        updateFunc={
          (field, value) => {
            if (['taxInclusion', 'taxType', 'currency'].indexOf(field) > -1) {
              updateFormData({ keyPath: [...basePath, field], fieldName: field, value: value.trim() }, 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG', 'location')
            } else {
              onTextFieldChangeWithKeyPath({
                keyPath: [...basePath, field],
                value,
              });
            }
          }
        }
      />
      <small style={{ color: 'red', display: 'block' }}>{extraProps.ratesTableError}</small>
      <div style={{ width: '75%' }}>
        <RateTemplate
          productType={productType}
          showHeader
          withEditableCell
          rateSet={extraProps}
          updateTableCell={payload => updateTableCell({ ...payload, pathToRates: basePath })}
          contractState={contractState}
          addRateDetails={newRates => onTextFieldChangeWithKeyPath({
            keyPath: [...basePath, 'rates'],
            value: newRates,
          })}
        />
      </div>
      {
        Boolean(invalidRateDescrs && invalidRateDescrs.length) && (<div style={{ color: '#ff6200', width: '75%' }}>
          The bedding configuration added for this room type does not allow for{invalidRateDescrs.length === 1 ? ' a' : ''} {invalidRateDescrs.join('/')} {pluralize('rate', invalidRateDescrs.length)}. Please update your bedding configuration in the Profile, or unselect {invalidRateDescrs.join('/')} as applicable.
        </div>)
      }
    </div>
  );
};

export default EditRateSet;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/edit-rates/edit-rate-set.jsx